import React from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'

import s from './Counter.scss'


const CartOrderItemCounter = ({ amount, onIncrease, onDecrease }) => (
  <div className={s.counter}>
    <div className={s.minus} onClick={onDecrease} data-testid={constants.testIds.payment.cartOrderItem.minus} />
    <div className={s.count} data-testid={constants.testIds.payment.cartOrderItem.count}>{amount}</div>
    <div className={s.plus} onClick={onIncrease} data-testid={constants.testIds.payment.cartOrderItem.plus} />
  </div>
)

CartOrderItemCounter.propTypes = {
  onIncrease: PropTypes.func,
  onDecrease: PropTypes.func,
}


export default CartOrderItemCounter
